<template>
	<div class="header" v-if="batches.length > 0 || loading">
		<v-card class="batch-wrapper" ref="card" v-horizontal-scroll v-if="batches.length > 0">
			<batch-header-button v-for="(batch, batchIndex) in batches" :key="batchIndex" :batch="batch" :subject-management="subjectManagement" :editable="editable" />
		</v-card>

		<v-overlay :value="loading" class="loader-overlay">
			<v-progress-circular indeterminate />
		</v-overlay>
	</div>
	<v-alert class="empty-batches" type="warning" dense v-else>
		Classes (batches) have not yet been imported
	</v-alert>
</template>

<script>
import BatchHeaderButton from './BatchHeaderButton';
import '../../directives/horizontal-scroll';

export default {
	props: ['batches', 'subjectManagement', 'loading', 'editable'],
	updated() {
		this.$emit('updated');
	},
	components: {
		BatchHeaderButton
	}
};
</script>

<style scoped>
.loader, .empty-batches {
	flex-grow: 1;
}

.header {
	position: relative;
	min-height: 2em;
	min-width: 0;
	flex-grow: 1;
}

.batch-wrapper {
	height: 100%;
	overflow-y: hidden;
	overflow-x: scroll;
	display: flex;
	flex-direction: row;
}

.batch-wrapper::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

/* Track */
.batch-wrapper::-webkit-scrollbar-track {
    background: #EEE; 
}

/* Handle */
.batch-wrapper::-webkit-scrollbar-thumb {
    background: #BBB; 
}

/* Handle on hover */
.batch-wrapper::-webkit-scrollbar-thumb:hover {
	background: #06F;
}

.loader-overlay {
	position: absolute;
	width: 100%;
}

.empty-batches {
	margin-bottom: 0;
}
.empty-batches:deep(.v-alert__wrapper) {
	justify-content: center;
}
.empty-batches:deep(.v-alert__content) {
	flex-grow: 0;
}
</style>